<div class="am-table-toolbar" >
    <a (click)="reload()" class="refresh">
        <i  class="fa fa-refresh fa-1x" aria-hidden="true"></i>
    </a>
    <h4>Logs</h4>
</div>
<table class="am-table am-table-divider am-table-hover am-table-fixed-header log-list">
    <thead>
        <tr>
            <th>Created at</th>
            <th>Updated at</th>
            <th>Type</th>
            <th>Message</th>
            <th>Body</th>
        </tr>
    </thead>
    <tbody>
        <tr *ngFor="let log of logs"(click)="openDetails(log)"
            [class.am-active]="log === selectedLog">
            <td>
                <p>{{log.created_at | date:'short'}}</p>
                <p class="am-time-ago">{{log.created_at | amTimeAgo:true}} ago</p>
            </td>
            <td>
                <p>{{log.updated_at | date:'short'}}</p>
                <p class="am-time-ago">{{log.updated_at | amTimeAgo:true}} ago</p>
            </td>
            <td>
                <p *ngFor="let type of log.type">{{type}}</p>
            </td>
            <td>{{log.message}}</td>
            <td>{{log.body ? 'Yes' : 'No'}}</td>
        </tr>
    </tbody>
</table>
<div class="table-detail" [class.open]="detailsOpen">
    <div class="table-detail-header">
        <a (click)="closeDetails()" class="close">
            <i  class="fa fa-times fa-1x" aria-hidden="true"></i>
        </a>
        <h4>Log details</h4>
    </div>
    <div class="table-detail-content">
        <table class="am-table am-table-stripped log-details" *ngIf="selectedLog">
            <tbody>
                <tr>
                    <td>Created at</td>
                    <td>{{selectedLog.created_at}}</td>
                </tr>
                <tr>
                    <td>Updated at</td>
                    <td>{{selectedLog.updated_at}}</td>
                </tr>
                <tr>
                    <td>Type</td>
                    <td>{{selectedLog.type}}</td>
                </tr>
                <tr>
                    <td>Message</td>
                    <td>{{selectedLog.message}}</td>
                </tr>
                <tr>
                    <td>Body</td>
                    <td><pre>{{selectedLog.body | json}}</pre></td>
                </tr>
            </tbody>
        </table>
    </div>
<div>
